<template #default>
  <div class="container-fluid p-0 m-0">
    <div class="row m-0 p-0  justifyCenter">
      <div class="col-10 m-0 p-0">
        <h4>2016</h4>
      </div>
    </div>

    <div class="row m-0 p-0  justifyCenter">
      <div class="col-3 m-0 p-0 text-center">
        <p v-if="sprachID === 0">Ausgabe 1</p>
        <p v-if="sprachID === 1">output 1</p>
        <img
          src="../../assets/Mitteilungsblatt/Titelbild/2016-1.jpg"
          class="Mitteilungsblattfoto zoom"
          alt="..."
        />
        <ul class="noDeko">
          <li
            class="borderRund"
            @click="openPDF('IHV/IHVHeft12016.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Inhaltsverzeichnis</span>
            <span v-if="sprachID === 1" class="bold">Table of Contents</span>
          </li>
          <li
            class="borderRund"
            @click="openPDF('Probeartikel/Probeartikel_1_2016.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Beispielartikel</span>
            <span v-if="sprachID === 1" class="bold">Example article</span>
          </li>
        </ul>
      </div>
      <div class="col-3 m-0 p-0 text-center">
        <p v-if="sprachID === 0">Ausgabe 2</p>
        <p v-if="sprachID === 1">output 2</p>
        <img
          src="../../assets/Mitteilungsblatt/Titelbild/2016-2.jpg"
          class="Mitteilungsblattfoto zoom"
          alt="..."
        />
        <ul class="noDeko">
          <li
            class="borderRund"
            @click="openPDF('IHV/IHVHeft22016.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Inhaltsverzeichnis</span>
            <span v-if="sprachID === 1" class="bold">Table of Contents</span>
          </li>
          <li
            class="borderRund"
            @click="openPDF('Probeartikel/Probeartikel_2_2016.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Beispielartikel</span>
            <span v-if="sprachID === 1" class="bold">Example article</span>
          </li>
        </ul>
      </div>
      <div class="col-3 m-0 p-0 text-center">
        <p v-if="sprachID === 0">Ausgabe 3</p>
        <p v-if="sprachID === 1">output 3</p>
        <img
          src="../../assets/Mitteilungsblatt/Titelbild/2016-3.jpg"
          class="Mitteilungsblattfoto zoom"
          alt="..."
        />
        <ul class="noDeko">
          <li
            class="borderRund"
            @click="openPDF('IHV/IHVHeft32016.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Inhaltsverzeichnis</span>
            <span v-if="sprachID === 1" class="bold">Table of Contents</span>
          </li>
          <li
            class="borderRund"
            @click="openPDF('Probeartikel/Probeartikel_3_2016.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Beispielartikel</span>
            <span v-if="sprachID === 1" class="bold">Example article</span>
          </li>
        </ul>
      </div>
      <div class="col-3 m-0 p-0 text-center">
        <p v-if="sprachID === 0">Ausgabe 4</p>
        <p v-if="sprachID === 1">output 4</p>
        <img
          src="../../assets/Mitteilungsblatt/Titelbild/2016-4.jpg"
          class="Mitteilungsblattfoto zoom"
          alt="..."
        />
        <ul class="noDeko">
          <li
            class="borderRund"
            @click="openPDF('IHV/IHVHeft42016.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Inhaltsverzeichnis</span>
            <span v-if="sprachID === 1" class="bold">Table of Contents</span>
          </li>
          <li
            class="borderRund"
            @click="openPDF('Probeartikel/Probeartikel_4_2016.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Beispielartikel</span>
            <span v-if="sprachID === 1" class="bold">Example article</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="row m-0 p-0 justifyCenter">
      <div class="col-4 m-0 p-0 text-center">
        <ul class="noDeko">
          <li class="borderRund" @click="openPDF('IHV/IHV2016.pdf')">
            <span class="bold">Jahresinhaltsverzeichnis</span>
          </li>          
        </ul>
      </div>
      <div class="col-4 m-0 p-0 text-center">
        <ul class="noDeko">
          <li class="borderRund" @click="openPDF('IHV/JIV2016-Pflanzennamen.pdf')">
            <span v-if="sprachID === 0" class="bold">Pflanzenverzeichnis</span>
            <span v-if="sprachID === 1" class="bold">Plant Directory</span>
          </li>          
        </ul>
      </div>
    </div>
  </div>
</template>
<script>

import { openModal } from "jenesius-vue-modal";
import modalPDF from "../../components/ModalPDF.vue";

export default {
  name: "J2016",
  methods: {
    openPDF(pdf) {
      const props = { pdf: pdf };
      openModal(modalPDF, props);
    },
  },
    computed: {
    sprachID() {
      let sprachID = this.$store.getters.getSprachID;
      return sprachID;
    },
  },
}



</script>